import { render, staticRenderFns } from "./redPacketRuleConfiguration.vue?vue&type=template&id=2265f33b&scoped=true&"
import script from "./redPacketRuleConfiguration.vue?vue&type=script&lang=js&"
export * from "./redPacketRuleConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./redPacketRuleConfiguration.vue?vue&type=style&index=0&id=2265f33b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265f33b",
  null
  
)

export default component.exports